defineDs('DanskeSpil/Domain/Subscriptions/Scripts/Utils/Slider', function () {

  const defaultConfig = {
    defaultPrefixName: 'DsSlider',
    name: '',
    staticName: true,
    container: {
      class: 'slider-container',
      width: '100%',
      minHeight: 'unset',
      height: 'auto',
    },
    containerItems: {
      class: 'slider-items'
    },
    containerItem: {
      class: 'slider-item',
      width: 300,
      height: 'auto',
      padding: 0
    },
    startIndex: -1,
    saveState: true,
    center: true,
    onLoad: null,
    onDrag: null,
    onClick: null,
    onDragEnd: null,
    onTransitionStart: null,
    onTransitionEnd: null,
    minDragThreshold: 10,
    responsive: {},

  };

  const slider = (config = {}) => {

    const setUniqueName = (name) => {
      const sliders = document.querySelectorAll('[id^="' + name + '"]');
      const count = sliders.length;
      return name + '_' + count;
    };

    const deepMerge = (target, source) => {
      const result = { ...target };
      for (const key in source) {
        if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
          result[key] = deepMerge(target[key] || {}, source[key]); // Recursively merge
        } else {
          result[key] = source[key]; // Use source value
        }
      }
      return result;
    };

    const getCenterItemIndex = () => {
      if (config.center) {
        if (sliderItems.length === 0) {
          return -1;
        }
        return Math.floor(sliderItems.length / 2);
      }
    };

    const getResponsiveStyles = () => {
      const width = window.innerWidth;
      const matchedBreakpoint = Object.keys(config.responsive).find((breakpoint) => width >= parseInt(breakpoint, 10));

      if (matchedBreakpoint) {
        return parseInt(config.responsive[matchedBreakpoint].itemWidth, 10);
      }
      return config.containerItem.width || 300;
    };

    const isNumber = (value) => typeof value === 'number' && Number.isFinite(value);
    const addPxIfNumber = (value) => (isNumber(value) ? `${value}px` : value);

    const saveState = (closestIndex) => {
      const indexToSave = closestIndex ? closestIndex : selectedIndex;
      window.config = window.config || {};
      window.config.dsslider = window.config.dsslider || {};
      window.config.dsslider[config._fullName] = {
        selectedIndex: indexToSave
      };
    };

    const getSavedState = () => {
      // Ensure `window.config` and `window.config.dsslider` exist
      if (window.config && window.config.dsslider) {
        // Return the saved state for the current slider by its name
        return window.config.dsslider[config._fullName] || null;
      }
      return null;

    };

    const removeSavedState = () => {
      if (!config._fullName) {
        return;
      }

      if (window.config && window.config.dsslider && window.config.dsslider[config._fullName]) {
        delete window.config.dsslider[config._fullName];
      }
    };

    const getInfo = () => {
      return {
        index: selectedIndex,
      };
    };

    config = deepMerge(defaultConfig, config);

    // Define a getter for the full name of the slider
    Object.defineProperty(config, '_fullName', {
      get: function () {
        if (this.staticName) {
          return `${this.defaultPrefixName}_${this.name}`;
        } else {
          return setUniqueName(`${this.defaultPrefixName}_${this.name}`);
        }
      },
      enumerable: true, // Makes _fullName visible when enumerating properties
      configurable: true, // Allows redefinition or removal of this property
    });



    let responsiveStyles = '';
    // Iterate over the responsive breakpoints and create media queries
    Object.keys(config.responsive).forEach((breakpoint) => {
      const itemWidth = addPxIfNumber(config.responsive[breakpoint].itemWidth);

      responsiveStyles += `
    @media (min-width: ${breakpoint - 1}px) {
      #${config._fullName} .${config.containerItem.class} {
        flex: 0 0 ${itemWidth};
        width: ${itemWidth};
        }
      }
    `;
    });

    // Check if the style tag already exists
    const styleTag = document.querySelector('style[data-id="' + config._fullName + '"]');

    if (!styleTag) {
      // Style slider and items
      const style = document.createElement('style');
      style.setAttribute('type', 'text/css');
      style.setAttribute('data-id', config._fullName);
      style.textContent = `
 
 #${config._fullName}.${config.container.class} {
      position: relative;    
      overflow: hidden;
      width: ${addPxIfNumber(config.container.width)};
      min-height: ${config.container.minHeight ? addPxIfNumber(config.container.minHeight) : 'inherit'};
      height: ${addPxIfNumber(config.container.height)};
      margin: 0 auto;
      perspective: 1000px;
      box-sizing: border-box;
      & * {
      box-sizing: border-box;
    }
  }
  #${config._fullName} .${config.containerItems.class} {
      display: flex;
      width: fit-content;
      transition: transform 0.3s ease;
      will-change: transform;
      cursor: grab;
  }
  #${config._fullName} .${config.containerItem.class} {
      flex: 0 0 ${addPxIfNumber(config.containerItem.width)};
      width: ${addPxIfNumber(config.containerItem.width)};
      padding: ${addPxIfNumber(config.containerItem.padding)};
      user-select: none;
      touch-action: none;
  }
  ${responsiveStyles}
`;
      document.head.appendChild(style);
    }

    let startX = 0;
    let startY = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let isDragging = false;
    let isClicking = false;
    let selectedIndex = null;

    const eventListeners = []; // Registry to track listeners for cleanup
    const sliderContainer = document.querySelector('.' + config.container.class);
    const sliderContainerItems = sliderContainer.querySelector('.' + config.containerItems.class);
    const sliderItems = sliderContainer.querySelectorAll('.' + config.containerItem.class);

    sliderContainer.setAttribute('id', config._fullName);

    const addEventListener = (target, type, handler, args) => {
      target.addEventListener(type, handler, args);
      eventListeners.push({ target, type, handler, args });
    };

    // Cleanup function to remove all attached listeners
    const cleanupListeners = () => {
      eventListeners.forEach(({ target, type, handler }) => {
        target.removeEventListener(type, handler);
      });
      eventListeners.length = 0;
    };

    // Function to center an item by index
    const centerItemByIndex = (index, animate = true) => {
      const sliderItemWidth = getResponsiveStyles(); // Get the width of each item
      const sliderContainerWidth = sliderContainer?.offsetWidth; // Get the container width

      if (!sliderContainerWidth || !sliderItemWidth) {
        return;
      }

      // Calculate the center offset
      const centerOffset = (sliderContainerWidth - sliderItemWidth) / 2;

      // Calculate the translation
      currentTranslate = (-index * sliderItemWidth) + centerOffset;

      // Apply animation if needed
      sliderContainerItems.style.transition = animate ? 'transform 0.3s ease' : 'none';
      sliderContainerItems.style.transform = `translateX(${currentTranslate}px) translateZ(0)`;

      // Save the selected index
      selectedIndex = index;

      // Save state if required
      if (config.saveState) {
        saveState();
      }
    };

    // Function to detect the closest item to the center
    const getClosestItemIndex = () => {
      const center = sliderContainer?.offsetWidth / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;

      sliderItems.forEach((item, index) => {
        const itemStart = item.offsetLeft + currentTranslate;
        const itemEnd = itemStart + item.offsetWidth;
        const itemCenter = (itemStart + itemEnd) / 2;
        const distance = Math.abs(center - itemCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      return closestIndex;
    };

    const onDragStart = (event) => {
      isDragging = true;
      isClicking = true; // Initially assume it might be a click
      startX = event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
      startY = event.type.includes('mouse') ? event.pageY : event.touches[0].clientY;
      prevTranslate = currentTranslate;
      sliderContainerItems.style.transition = 'none';
      addEventListener(document, 'mousemove', onDragMove);
      addEventListener(document, 'touchmove', onDragMove, { passive: false });
      addEventListener(document, 'mouseup', onDragEnd);
      addEventListener(document, 'touchend', onDragEnd, { passive: true });
    };

    const onDragMove = (event) => {
      if (!isDragging) return;
      isClicking = false; // If movement occurs, it's not a click
      const currentX = event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
      const currentY = event.type.includes('mouse') ? event.pageY : event.touches[0].clientY;

      const deltaX = currentX - startX;
      const deltaY = currentY - startY;

      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        event.preventDefault();
        currentTranslate = prevTranslate + deltaX;
        sliderContainerItems.style.transform = `translateX(${currentTranslate}px) translateZ(0)`;

        const closestIndex = getClosestItemIndex();

        if (config.saveState) {
          saveState(closestIndex);
        }

        if (config.onDrag) {
          config.onDrag();
        }
      }
    };

    const onTransitionStart = (event) => {
      if (config.onTransitionStart) {
        config.onTransitionStart(event);
      }
    };

    const onTransitionEnd = (event) => {

      if (config.onTransitionEnd) {
        config.onTransitionEnd(event);
      }
    };

    const onDragEnd = () => {
      if (!isDragging) return;
      isDragging = false;

      const dragDistance = currentTranslate - prevTranslate;

      if (Math.abs(dragDistance) < config.minDragThreshold) {
        centerItemByIndex(getClosestItemIndex()); // Snap back to the current item
        return;
      }

      // Determine the direction of the drag
      const direction = dragDistance > 0 ? -1 : 1;

      // Calculate the closest item based on drag direction
      let closestIndex = selectedIndex + direction;

      // Ensure closestIndex stays within bounds
      closestIndex = Math.max(0, Math.min(sliderItems.length - 1, closestIndex));

      // Center the item at the new index
      centerItemByIndex(closestIndex);

      if (config.onDragEnd) {
        config.onDragEnd();
      }
    };

    addEventListener(sliderContainerItems, 'mousedown', onDragStart);
    addEventListener(sliderContainerItems, 'touchstart', onDragStart);

    if (config.onTransitionStart) {
      addEventListener(sliderContainerItems, 'transitionstart', onTransitionStart);
    }

    if (config.onTransitionEnd) {
      addEventListener(sliderContainerItems, 'transitionend', onTransitionEnd);
    }

    addEventListener(window, 'resize', () => {
      const closestIndex = selectedIndex ? selectedIndex : getClosestItemIndex();
      centerItemByIndex(closestIndex, false);
    });

    // Click to center the item
    sliderItems.forEach((item, index) => {

      addEventListener(item, 'click', (event) => {
        if (isDragging || !isClicking) return;
        event.preventDefault();
        if (config.onClick) config.onClick(event, item, index);
        centerItemByIndex(index, true);
      });
    });

    const savedState = getSavedState();

    if (config.saveState && savedState?.selectedIndex >= 0) {
      centerItemByIndex(savedState.selectedIndex, false);
    } else if (config.startIndex > -1) {
      centerItemByIndex(config.startIndex, false);
    } else if (config.center) {
      let centerIndex = getCenterItemIndex();
      centerItemByIndex(centerIndex, false);
    }

    if (config.onLoad) {
      config.onLoad();
    }

    return {
      getInfo,
      centerItemByIndex,
      getClosestItemIndex,
      removeSavedState,
      cleanup: cleanupListeners, // Expose cleanup method
    };
  };

  return {
    init: slider,
  };
});
